<template>
  <div class="ima-users">

    <ima-loading-spinner v-if="users.isLoading"></ima-loading-spinner>

    <div v-else>
      <h1 class="title">Benutzer</h1>

      <ima-filter-toolbar :activeFilters="activeFilters">

        <b-field>
          <b-input placeholder="Suchen" type="search" icon="search" v-model="filter.term.value"></b-input>
        </b-field>

        <b-field>
          <b-dropdown @change="(value)=>addFilter('roles', value)">
            <button class="button" slot="trigger">
              <b-icon icon="perm_identity" size="is-small"></b-icon>
              <span>Rolle</span>
              <b-icon icon="arrow_drop_down"></b-icon>
            </button>
            <b-dropdown-item v-for="role in options.roles" :value="role" :key="role.id">{{role.label}}</b-dropdown-item>
          </b-dropdown>
        </b-field>

      </ima-filter-toolbar>

      <b-table class="ima-users-list__table" :data="filteredData" :checked-rows.sync="selected" :striped="true" :checkable="true" :loading="users.isLoading" :mobile-cards="true" :paginated="true" :per-page="25" :pagination-simple="true" default-sort="['id']">

        <template slot-scope="props">
          <b-table-column field="id" label="ID" sortable numeric>
            {{ props.row.id }}
          </b-table-column>

          <b-table-column field="firstName" label="Vorname" sortable>
            {{ props.row.firstName }}
          </b-table-column>

          <b-table-column field="lastName" label="Nachname" sortable>
            {{ props.row.lastName }}
          </b-table-column>

          <b-table-column field="email" label="E-Mail" sortable>
            {{ props.row.email }}
          </b-table-column>

          <b-table-column field="email" label="Rollen" numeric>

            <span v-for="role in getRoleLabelsByIds(props.row.roles)" :key="role" class="tag is-light">{{role}}</span>

          </b-table-column>

          <b-table-column field="actions" label=" ">
            <div class="control">

              <button v-if="canEditUsers && canEditSpecificUser(props.row)" class="button round-button is-primary" type="button" @click="onUserEdit(props.row)">
                <span class="icon">
                  <b-icon icon="mode_edit"></b-icon>
                </span>
              </button>

              <button v-if="canDeleteUsers && canDeleteSpecificUser(props.row)" class="button round-button is-danger" type="button" @click="onUserRemove(props.row)">
                <span class="icon">
                  <b-icon icon="delete" />
                </span>
              </button>

            </div>
          </b-table-column>

        </template>

        <div slot="empty">
          Keine Schilder verfügbar
        </div>
      </b-table>

      <button v-if="this.canCreateUsers" class="button floating-button" @click="openUserModal()">
        <b-icon icon="add"></b-icon>
      </button>
    </div>

  </div>
</template>

<script>
import routes from '@/mixins/routes'
import { mapState, mapMutations, mapActions } from 'vuex'
import { fetchUsers, selectUser, deleteUser } from '@/store/modules/users'
import { openUserModal } from '@/store/modules/modals'
import filterListing from '@/mixins/filter-listing'
import { intersection } from 'lodash'
import LoadingSpinner from '@/components/LoadingSpinner'
import FilterToolbar from '@/components/FilterToolbar'
import {
  canCreateUsers,
  canDeleteUsers,
  canDeleteSpecificUser,
  canEditUsers,
  canEditSpecificUser
} from '@/services/permissions'

export default {
  name: 'ima-users',
  components: {
    'ima-loading-spinner': LoadingSpinner,
    'ima-filter-toolbar': FilterToolbar
  },
  mixins: [routes, filterListing],
  data () {
    return {
      filter: {
        term: {
          value: null,
          filter (user) {
            return [
              user.id,
              user.firstName,
              user.lastName,
              user.userName,
              user.email
            ]
              .join()
              .toLowerCase()
              .includes(this.value.toLowerCase())
          }
        },
        roles: {
          label: 'Rolle',
          values: [],
          filter (user) {
            return !!intersection(
              this.values.map(({ value }) => value),
              user.roles
            ).length
          }
        }
      },
      selected: []
    }
  },
  methods: {
    ...mapMutations([openUserModal, selectUser]),
    ...mapActions([fetchUsers, deleteUser]),
    getRoleLabelsByIds (roleIds) {
      return roleIds.map(
        roleId => this.roles.data.find(({ id }) => id === roleId).name
      )
    },
    canDeleteSpecificUser (user) {
      return canDeleteSpecificUser(user)
    },
    canEditSpecificUser (user) {
      return canEditSpecificUser(user)
    },
    onUserEdit (user) {
      this.selectUser(user)
      this.openUserModal()
    },
    onUserRemove (user) {
      this.$dialog.confirm({
        title: 'User löschen',
        message: `Sind Sie sicher dass Sie den Benutzer <strong>${user.firstName} ${user.lastName}</strong> unwiderruflich <strong>löschen</strong> wollen?`,
        confirmText: 'User löschen',
        cancelText: 'Abbrechen',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.deleteUser(user)
        }
      })
    }
  },
  computed: {
    ...mapState(['users', 'roles', 'user']),
    options () {
      return {
        roles: this.roles.data.map(({ id, name }) => ({
          value: id,
          label: name
        }))
      }
    },
    filteredData () {
      return this.filterCollection(this.users.data)
    },
    canCreateUsers () {
      return canCreateUsers()
    },
    canDeleteUsers () {
      return canDeleteUsers()
    },
    canEditUsers () {
      return canEditUsers()
    }
  },
  created () {
    this.fetchUsers()
  }
}
</script>

<style lang="scss">
.ima-users {
}
</style>




// WEBPACK FOOTER //
// src/components/UserList.vue